import * as React from "react";
const DistributeFullWidthSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 15v1H3v-1h13Zm-1-8a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h11Zm0 1H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Zm1-5v1H3V3h13Z" }));
DistributeFullWidthSmall.displayName = "DistributeFullWidthSmall";
var DistributeFullWidthSmall_default = DistributeFullWidthSmall;
export {
  DistributeFullWidthSmall_default as default
};
